var cov_wrfwlg4bf = function () {
  var path = "/Users/spana/SHEIN/shineout/src/DatePicker/styles/index.ts",
      hash = "14ebabe38f88f629331a50a1925de5546dd76aa3",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/DatePicker/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 5,
          column: 71
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var datepickerLess = {};
import genaration from '../../utils/classname';
export var datepickerClass = (cov_wrfwlg4bf.s[0]++, genaration(datepickerLess, 'datepicker'));